export default __webpack_public_path__ + "static/media/bg.9b769d34.jpg";